//component seems unused. added to eslint ingore. leaving here for now just in case.

import { Component, HostBinding, inject, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { RightBridgeApiService } from '../../../services/right-bridge-api.service';

@Component({
  selector: 'app-form-incomeChart',
  styleUrls: ['form-incomeChart.component.scss'],
  template: `<<<<<<<<<<<<<<<<<<<< HELLLOOO!!!!!!! >>>>>>>>>>>>>>>>>>>>><div
      >chart</div
    ><button mat-button (click)="getChartData($event)">Get Chart Data</button
    ><div>table</div>`,
  imports: [],
})
export class FormlyIncomeChartComponent extends FieldType implements OnInit {
  private rbs = inject(RightBridgeApiService);

  @HostBinding('class') classes = 'w-100 form-section row';

  data = {
    Client: {
      Type: null,
    },
    ClientEstimates: {
      RetirementAge: null,
    },
    ClientFinancial: {
      ExpectedPensionAtRetirement: null,
      HouseholdIncome: null,
      Income: null,
      InvestableAssets: null,
      OtherRetirementIncome: null,
      Salary: null,
    },
    ClientLiabilities: {
      RevolvingBalance: null,
    },
    ClientPerson: {
      Age: null,
      EmploymentStatus: null,
      IsMarried: null,
      MaritalStatus: null,
    },
    ClientProfiling: {
      AssetsKnown: null,
      FundingGoal: null,
      PercentofTotalIncomeAtRet: null,
      PVDollarofTotalIncomeAtRet: null,
      RetirementAssetDraw: null,
      RetirementAssetPreserved: null,
      RetirementIncomeGoalType: null,
      SocialSecuritySource: null,
      UseDollarorPercentforFVAtRet: null,
    },
    HeldAwayAccount: {
      MarketValue: null,
    },
    HeldAwayAnnuityContract: {
      CashValue: null,
    },
    HeldAwayLIPolicy: {
      CashValue: null,
    },
    HouseholdIncome: {
      Amount: null,
      Duration: null,
      Owner: null,
      Type: null,
    },
    MGPConversions: {
      HasRetirementPlan: null,
    },
    NeedsAnalysis: {
      EstimatedAssetsAtRetirement: null,
      EstimatedIncomeAtRetirement: null,
      TargetIncomeAtRetirement: null,
      UseExternalCalcs: null,
      UseMGPIncomeResults: null,
      UseMGPIncomeResults2: null,
      UseMGPRetirementGoal: null,
    },
    RetirementIncomeAssumptions: {
      AssetGrowthRatePostRetire: null,
      AssetGrowthRatePreRetire: null,
      AssetGrowthRatePreRetire1: null,
      AssetGrowthRatePreRetire2: null,
      AssetGrowthRatePreRetire3: null,
      LifeExpectancy: null,
      WageInflationRate: null,
    },
    RetirementSavings: {
      AnnualContributionPercent: null,
      AnnualContributions: null,
      PercentOrAmount: null,
    },
    RuleParamEstimatedRetirementIncome: {
      PostRetireInflationRate: null,
      RetirementAge: null,
    },
    SocSecHistoricalWages: {
      IndexFactor: null,
      MaxIncome: null,
      WageGrowthRate: null,
      Year: null,
      YearsBack: null,
    },
    SpouseEstimates: {
      RetirementAge: null,
    },
    SpouseFinancial: {
      ExpectedPensionAtRetirement: null,
      Income: null,
    },
    SpousePerson: {
      Age: null,
      Include: null,
    },
    SpouseRetirementSavings: {
      AnnualContributionPercent: null,
      AnnualContributions: null,
    },
    UnitClientInfo: {
      UseHouseholdIncome: null,
    },
  };
  ngOnInit(): void {
    this.updateData();
  }

  updateData() {
    const dataEntries = Object.entries(this.data);

    dataEntries.forEach(([key, value]) => {
      const subEntries = Object.keys(value);

      subEntries.forEach(subKey => {
        this.data[key][subKey] = this.model[`${key}_${subKey}`] || null; // Ensure the subKey exists in model
      });
    });
  }

  getChartData(ev) {
    ev.preventDefault();
    this.updateData(); // Ensure data is updated before fetching
    this.rbs
      .postGroupProfile('GuaranteedIncomeBridges', null, this.data)
      .subscribe(() => {});
  }
}
